/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `draft` - Szkic
 * * `scheduled` - Zaplanowany
 * * `published` - Opublikowany
 * * `archived` - Zarchiwizowany
 * * `cancelled` - Anulowany
 */
export type OperatorPushQuizStateEnum = typeof OperatorPushQuizStateEnum[keyof typeof OperatorPushQuizStateEnum];


export const OperatorPushQuizStateEnum = {
  draft: 'draft',
  scheduled: 'scheduled',
  published: 'published',
  archived: 'archived',
  cancelled: 'cancelled',
} as const;
